import { render, staticRenderFns } from "./iconClipboard.vue?vue&type=template&id=0f55818a"
import script from "./iconClipboard.vue?vue&type=script&lang=js"
export * from "./iconClipboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports